import queryString from 'query-string';
import * as types from '../actiontypes';
import Env from '../../util/env';
import {actionTypesEnum, serviceURL} from '../../util/uiconstants';

const getUserPresenceApiUrl = (engagementId, objectId, query) =>
	`${Env.getBaseURL(serviceURL, engagementId)}userPresences/${objectId}?${queryString.stringify(query)}`;

// Makes a call to api/engagements/{engagementId}/userPresences/{id}
export function getUserPresence(
	engagementId,
	objectId,
	entityId = undefined,
	objectActionTypeId = actionTypesEnum.Open
) {
	const url = getUserPresenceApiUrl(engagementId, objectId, {
		entityId,
		objectActionTypeId
	});

	return {
		type: types.GET_USER_PRESENCE,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		},
		objectId
	};
}

// Makes a call to api/engagements/{engagementId}/userPresences/{id} and takes control from the specified object
export function deleteUserPresence(
	engagementId,
	objectId,
	entityId = undefined,
	objectActionTypeId = actionTypesEnum.Open
) {
	const url = getUserPresenceApiUrl(engagementId, objectId, {
		entityId,
		objectActionTypeId
	});

	return {
		type: types.DELETE_USER_PRESENCE,
		meta: {
			api: {
				url: url,
				method: 'DELETE'
			}
		},
		objectId
	};
}

export function resetUserPresence(objectId) {
	return {
		type: types.RESET_USER_PRESENCE,
		objectId
	};
}
